// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\"><path d=\"M5 11h14v2H5z\"/></svg>";
// Exports
module.exports = code;